import React from 'react';
import PropTypes from 'prop-types';

const PayrollStep = props => {
  const {text, isCurrent} = props
  return (
    <div className={`payroll-step s-relative s-w-8px s-center s-main-center ${isCurrent && 'is-current'}`}>
      <div className="s-w-8px s-h-8px circle-radius s-bg-blue dot" />
      <p className="s-mb-0 smallest">{text}</p>
    </div>
  );
};

PayrollStep.propTypes = {
  text: PropTypes.string.isRequired,
  isCurrent: PropTypes.bool,
};

PayrollStep.defaultProps = {
  isCurrent: false,
}

export default PayrollStep;
